import React from "react"
import {AUTH_CREDENTIALS_NAME} from "./../Constantes"
import { Redirect, Route } from "react-router-dom"
import {usePermiso} from "./../hooks/usePermiso"
import { useActivo } from "../hooks/useActivo"
export const PrivateRoute = ({component: Component, ...rest }) => {
    const [permitido] = usePermiso({ location: rest.idRuta })
    const [activo] = useActivo()
    return (
        <Route 
        {...rest} 
            render = { props =>
                (localStorage.getItem(AUTH_CREDENTIALS_NAME) && permitido && activo) ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to = {{
                            pathname: "/login",
                            state: {from: props.location}
                        }}
                    />
                )
            }
        >
        </Route>
    )
};